__turbopack_context__.v({
  "container": "Copy-module__xbvUcW__container",
});
